<template>
  <v-card>
    <v-card-title class="secondary lighten-4">
      <span class="body-2">Update Claim Status</span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex lg6 md6 xs12>
            <v-autocomplete
              :items="claimStatList"
              v-validate="'required'"
              v-model="claimForm.clmStat"
              :label="labels.clmStat"
              item-text="label"
              item-value="value"
              data-vv-name="clmStat"
              :error-messages="errors.collect('clmStat')"
              :data-vv-as="labels.clmStat"
              @change="doCauseList(claimForm.clmStat)"
            ></v-autocomplete>
          </v-flex>
          <v-flex lg6 md6 xs12>
            <v-autocomplete
              :items="causeStatList"
              v-model="claimForm.cseStat"
              :label="labels.cseStat"
              item-text="label"
              item-value="value"
              data-vv-name="cseStat"
              :data-vv-as="labels.cseStat"
              :error-messages="errors.collect('cseStat')"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click.native="doCancel">Cancel</v-btn>
      <v-btn color="primary" text type="submit" @click="doSave">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { CLAIMS_CLAIMDETAIL_EDITSTATUS } from '@/store/types'
// As local state management is quite hard to share between components, we will duplicate some info from ClaimStatusDialog.vue
// Validation and data to follow exact format of ClaimStatusDialog.vue
export default {
  data() {
    return {
      labels: {
        clmStat: 'Claim Status',
        cseStat: 'Cause of Status'
      },
      claimForm: {
        usrId: undefined,
        clmStat: undefined,
        cseStat: undefined
      },
      claimStatList: [],
      causeStatList: [],
      defCauseStatList: []
    }
  },
  computed: {
    claimStatus() {
      return this.$store.state.claims.claimDetail.commonInfo.claimStatuses[0]
    }
  },
  methods: {
    async init() {
      this.getClaimStats()
      this.claimForm.clmNo = this.$store.state.claims.claimDetail.commonInfo.clmNo
      this.claimForm.clmStat = this.claimStatus.clmStat
      this.claimForm.cseStat = this.claimStatus.cseStat
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doSaveClaimStatus().then((saveResult) => {
            if (saveResult) {
              this.$store.commit(CLAIMS_CLAIMDETAIL_EDITSTATUS, this.claimForm)
              this.$emit('close')
            }
          })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doSaveClaimStatus() {
      try {
        await this.$store.dispatch('saveClaimStatus', this.claimForm)
        return true
      } catch (err) {
        return false
      }
    },
    doCancel() {
      // revert the state
      this.init()
      this.$emit('close')
    },
    async getClaimStats() {
      const apiURI = this.$store.state.claims.claimRegister.menu.getClaimStats
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          this.claimStatList = []
          this.defCauseStatList = []
          if (data) {
            data.map((item) => {
              const claimStat = {
                value: item.clmStat,
                label: item.clmStatDesc
              }
              item.clmStatCauseList.map((element) => {
                const causeStat = {
                  value: element.value,
                  secondaryValue: element.secondaryValue,
                  label: element.label
                }
                this.defCauseStatList.push(causeStat)
              })
              this.claimStatList.push(claimStat)
              if (this.claimForm.clmStat !== undefined) {
                this.doCauseList(this.claimForm.clmStat)
              }
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doCauseList(value) {
      this.causeStatList = []
      this.defCauseStatList.map((item) => {
        if (item.secondaryValue === value) {
          const causeStat = {
            label: item.label,
            value: item.value
          }
          this.causeStatList.push(causeStat)
        }
      })
    }
  },
  mounted() {
    // Load state
    this.init()
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
